import { LocaleEnum } from '@/enums/localeEnum'

export type LocaleType = typeof LocaleEnum[keyof typeof LocaleEnum]

export type LocaleSettingsType = {
  locale: LocaleType
  originalLocale: string
  fallback: LocaleType
  availableLocales: LocaleType[]
}

export const localeSettings: LocaleSettingsType = {
  locale: LocaleEnum.CN,
  fallback: LocaleEnum.CN,
  originalLocale: LocaleEnum.CN,
  availableLocales: [
    LocaleEnum.US,
    LocaleEnum.CN,
    LocaleEnum.TW,
    LocaleEnum.RU,
    LocaleEnum.FR,
    LocaleEnum.DE,
  ],
}

export const LocaleOptions: { label: string; value: LocaleType }[] = [
  {
    label: '中文',
    value: LocaleEnum.CN,
  },
  {
    label: 'English',
    value: LocaleEnum.US,
  },
  {
    label: '日本語',
    value: LocaleEnum.JP,
  },
  {
    label: '中文(繁體)',
    value: LocaleEnum.TW,
  },
  {
    label: 'Pусский язык',
    value: LocaleEnum.RU,
  },
  {
    label: 'Français',
    value: LocaleEnum.FR,
  },
  {
    label: 'Español',
    value: LocaleEnum.SN_US,
  },
  {
    label: 'Čeština',
    value: LocaleEnum.CZ,
  },
  {
    label: 'România',
    value: LocaleEnum.RO,
  },
  {
    label: 'Deutsche',
    value: LocaleEnum.DE,
  },
]
